import AssociatedItem from './associated-item';
export default AssociatedItem